module.exports = __webpack_public_path__ + "img/icon-wholesale-market-area.1b6bd66d.png";